export const URL_CONSTANT = {
  HOME_URL: "/",
};
